@import ../../../styles/helpers

.user
    position: relative
    height: 100%
    display: flex
    align-items: center
    justify-content: center
    +m
        position: static

.wallet
    margin-left: 12px
    +m
        display: none

.currency
    color: $green

.code
    display: flex
    align-items: center
    margin-bottom: 8px

.number
    font-weight: 500
    color: $neutrals4

.copy
    margin-left: 8px
    svg
        fill: $blue
        transition: fill .2s
    &:hover
        svg
            fill: darken($blue, 10)

.line
    display: flex
    align-items: center
    margin-bottom: 10px

.preview
    flex-shrink: 0
    width: 40px
    height: 40px
    margin-right: 16px
    img
        width: 100%
        height: 100%
        border-radius: 50%

.info
    +caption-2
    color: $neutrals4

.price
    +body-bold-1

.connect
    height: 40px
    padding: 0px
    width: 130px